var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWantToLearn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5C9.5 1.08579 9.16421 0.75 8.75 0.75C8.33579 0.75 8 1.08579 8 1.5V2.5C8 2.91421 8.33579 3.25 8.75 3.25C9.16421 3.25 9.5 2.91421 9.5 2.5V1.5Z",
    fill: "#54687D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28033 3.46967C3.98744 3.17678 3.51256 3.17678 3.21967 3.46967C2.92678 3.76256 2.92678 4.23744 3.21967 4.53033L3.71967 5.03033C4.01256 5.32322 4.48744 5.32322 4.78033 5.03033C5.07322 4.73744 5.07322 4.26256 4.78033 3.96967L4.28033 3.46967Z",
    fill: "#54687D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2197 3.46967C13.5126 3.17678 13.9874 3.17678 14.2803 3.46967C14.5732 3.76256 14.5732 4.23744 14.2803 4.53033L13.7803 5.03033C13.4874 5.32322 13.0126 5.32322 12.7197 5.03033C12.4268 4.73744 12.4268 4.26256 12.7197 3.96967L13.2197 3.46967Z",
    fill: "#54687D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 11.1227V13C11.25 13.5523 10.8023 14 10.25 14C10.25 14.5523 9.80228 15 9.25 15H8.25C7.69772 15 7.25 14.5523 7.25 14C6.69772 14 6.25 13.5523 6.25 13V11.1227C5.33554 10.3896 4.75 9.26319 4.75 8C4.75 5.79086 6.54086 4 8.75 4C10.9591 4 12.75 5.79086 12.75 8C12.75 9.26319 12.1645 10.3896 11.25 11.1227ZM9.75 10.3104V12.5H7.75V10.3104L7.50109 10.1665C6.74992 9.73194 6.25 8.92346 6.25 8C6.25 6.61929 7.36929 5.5 8.75 5.5C10.1307 5.5 11.25 6.61929 11.25 8C11.25 8.92347 10.7501 9.73194 9.99891 10.1665L9.75 10.3104Z",
    fill: "#54687D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWantToLearn);
export default __webpack_public_path__ + "static/media/want-to-learn.091ad158e4d859930b9fa53623cfb181.svg";
export { ForwardRef as ReactComponent };